import {BaseServiceModel} from '../../classes/base-service.model';


export class ServiceModel extends BaseServiceModel {

    get isManager(): boolean {
        return this.id === 'ft-manager.service';
    }
}
